import { Permission as ApiPermission } from '@infuse/api/iam/permission';
import { Permission } from './model';

export const mapToDomain = (apiPermission: ApiPermission): Permission => {
  return {
    ...apiPermission,
    category: {
      id: `${apiPermission.category}.${apiPermission.subscriptionId}`,
      name: apiPermission.category
    }
  };
};
